export default "__VITE_ASSET__CRVgX1lT__";